import React, { useCallback, useContext, useMemo, useRef } from "react";
import { deepClone } from "../API/utils/deepClone";
export type FilterType = {
  userStatusFilter: string[];
  levelFilter: string[];
  ownerFilter: string[];
  groupFilter: string[];
  productFilter: string[];
};
export type FilterKeyType = keyof FilterType;
export type Filter = {
  resetFilter: Function;
  setFilter: (key: FilterKeyType | null, values: any) => void;
  getFilter: (key?: FilterKeyType) => FilterType | string[];
  getDefault: any;
};

const FilterContext = React.createContext<Filter>(null!);
export const useFilter = () => {
  return useContext(FilterContext);
};

export const FilterProvider = ({ children }: any) => {
  const filter = useProvideFilters();
  return (
    <FilterContext.Provider value={filter}>{children}</FilterContext.Provider>
  );
};

const useProvideFilters = () => {
  const defaultFilter = useMemo(
    () =>
      deepClone({
        userStatusFilter: ["true"],
        levelFilter: [],
        ownerFilter: [],
        groupFilter: [],
        productFilter: [],
      }),
    []
  );
  const getDefault = useCallback(
    () => deepClone(defaultFilter),
    [defaultFilter]
  );

  const getFilter = useCallback((filter?: FilterKeyType) => {
    if (filter) return deepClone(filtersref.current[filter]);
    return deepClone(filtersref.current);
  }, []);

  const filtersref = useRef<FilterType>({
    userStatusFilter: ["true"],
    levelFilter: [],
    ownerFilter: [],
    groupFilter: [],
    productFilter: [],
  });
  const setFilter = useCallback((filter: FilterKeyType | null, value: any) => {
    if (!filter && value != null) {
      filtersref.current = deepClone(value) as any;
    } else if (
      filter != null &&
      filtersref.current &&
      (filtersref.current?.[filter] as any)
    ) {
      filtersref.current[filter] = deepClone(value);
    }
  }, []);

  const resetFilter = useCallback(() => {
    filtersref.current = deepClone({
      userStatusFilter: ["true"],
      levelFilter: [],
      ownerFilter: [],
      groupFilter: [],
      productFilter: [],
    });
  }, []);

  return {
    resetFilter,
    setFilter,
    getFilter,
    getDefault,
  };
};
